
  import Events from '@/events/Events';
  import ProfileImagesPortrait from '@/components/candidate/ProfileImage/ProfileImagesPortrait';
  export default {
    name: 'ImagesForm',
    components: {
      ProfileImagesPortrait,
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      job: {
        type: Object,
        required: false,
        default: () => {},
      },
      comeFrom: {
        type: String,
        required: false,
        default: 'detailPage',
      },
    },
    data() {
      return {
        disabled: false,
      };
    },
    methods: {
      saveImages() {
        this.disabled = true;
        this.$emitWithClientData(
          this.comeFrom === 'AfterRegistration'
            ? Events.RegistrationBeforeApplicationStepFinished
            : Events.UpdateAndApplicationStepFinished,
          {
            jobPostingId: this.job.id,
            step: 'Images',
          }
        );
        this.$emit('change-step');
        setTimeout(() => (this.disabled = false), 3000);
      },
    },
  };
